export class TipoBeneficio {
   static Descuento = "DISCOUNT";
   static Souvenir = "SOUVENIR";
}

export class MecanicaPromocion {
   static Cantidad = "QUANTITY";
   static Paquete = "PACK";
}

export class TipoProductoParticipante {
   static Producto = "PRODUCTO";
   static Linea = "LINEA";
   static LineaPresentacion = "LINEA_PRESENTACION";
   static TODOS = "*";
}